import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDLYN1sYe5UhpcbiPKUD4z9GdrLmG2u_fI",
  authDomain: "beltran-psico-eu.firebaseapp.com",
  projectId: "beltran-psico-eu",
  storageBucket: "beltran-psico-eu.firebasestorage.app",
  messagingSenderId: "244342024524",
  appId: "1:244342024524:web:019444812afe30c9f807e9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);